import angular from 'angular';
import cloneDeep from 'clone-deep';
import createModal from './createModal.html';
import deleteModal from './deleteModal.html';
import editModal from './editModal.html';
import moveModal from './moveModal.html';

/* @ngInject */
export default function (params) {
	let {
		    $scope,
		    $stateParams,
		    toastr,
		    DocumentsDirectories,
		    STATUSES,
		    $uibModal,
		    localStorageService,
	    } = params;

	const getDirectoryWithPermissionsAndParent = (directoryId) => {
		return DocumentsDirectories.one(directoryId)
		                           .get({
			                           include: 'permissions.user,permissions.serviceUser,parent',
		                           })
		                           .then((directory) => {
			                           if (directory.permissions === undefined) {
				                           directory.permissions = [];
			                           }

			                           if (directory.parent === undefined) {
				                           directory.parent = null;
			                           } else {
				                           directory.parent = directory.parent.id;
			                           }

			                           return directory;
		                           });
	};

	const getDirectoryWithDescendantsAndParent = (directoryId) => {
		return DocumentsDirectories.one(directoryId)
		                           .get({
			                           include: 'descendants,documents,parent',
		                           })
		                           .then((directory) => {
			                           if (directory.parent === undefined) {
				                           directory.parent = null;
			                           } else {
				                           directory.parent = directory.parent.id;
			                           }

			                           return directory;
		                           });
	};

	const normalizePermissionsFromAPI = (permissions) => {
		let output = [];

		angular.forEach(permissions, (item) => {
			let permission = {
				...cloneDeep(item),
			};

			if (item.user !== undefined) {
				permission.user = item.user.id;
			} else {
				permission.user = null;
			}

			if (item.serviceUser !== undefined) {
				permission.serviceUser = item.serviceUser.id;
			} else {
				permission.serviceUser = null;
			}

			if (permission.gate !== null) {
				permission.type = 'gate';
			} else if (permission.category !== null) {
				permission.type = 'category';
			} else if (permission.user !== null) {
				permission.type = 'user';
			} else if (permission.serviceUser !== null) {
				permission.type = 'serviceUser';
			} else {
				permission.type = 'public';
			}

			output.push(permission);
		});

		return output;
	};

	const normalizePermissionsForAPI = (permissions) => {
		return permissions.filter((permission) => {
			                  if (!permission.permission) {
				                  return false;
			                  }

			                  switch (permission.type) {
				                  case 'gate': {
					                  return (permission.gate);
				                  }

				                  case 'category': {
					                  return (permission.category);
				                  }

				                  case 'user': {
					                  return (permission.user);
				                  }

				                  case 'serviceUser': {
					                  return (permission.serviceUser);
				                  }

				                  case 'public': {
					                  return true;
				                  }

				                  default: {
					                  return false;
				                  }
			                  }
		                  })
		                  .map((permission) => {
			                  let output = {
				                  ...cloneDeep(permission),
				                  gate:        null,
				                  category:    null,
				                  user:        null,
				                  serviceUser: null,
			                  };

			                  if (output.id !== undefined) {
				                  delete output.id;
			                  }

			                  switch (permission.type) {
				                  case 'gate': {
					                  output.gate = permission.gate;

					                  break;
				                  }

				                  case 'category': {
					                  output.category = permission.category;

					                  break;
				                  }

				                  case 'user': {
					                  output.user = permission.user;

					                  break;
				                  }

				                  case 'serviceUser': {
					                  output.serviceUser = permission.serviceUser;

					                  break;
				                  }

				                  default: {
					                  break;
				                  }
			                  }

			                  return output;
		                  });
	};

	$scope.directoryId = $stateParams.directoryId;

	$scope.directory = {
		data:   null,
		status: STATUSES.UNLOADED,
	};

	$scope.syncSelectedScopeDirectoryWithSelectedTreeDirectory = (newValue) => {
		$scope.directoryId = (newValue !== undefined) ? (newValue) : ($scope.treeSelectedDirectoryId);
	};

	$scope.directorySelectDirectory = (directoryId) => {
		$scope.directoryId = directoryId;
	};

	$scope.directoryUploadDocument = (directoryId) => {
		$scope.documentUploadDocument(directoryId);
	};

	$scope.directoryNewDirectory = (parentDirectoryId) => {
		$uibModal.open({
			animation:                  true,
			template:                   createModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				if (parentDirectoryId) {
					$scope.modalParentDirectory = $scope.directoriesById[parentDirectoryId];
				} else {
					$scope.modalParentDirectory = null;
				}

				$scope.modalDirectory = {
					name:        '',
					parent:      parentDirectoryId,
					permissions: [
						{
							type:        'gate',
							gate:        'staff',
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  'BROWSE',
						},
						{
							type:        'gate',
							gate:        'staff',
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  'EDIT',
						},
						{
							type:        'gate',
							gate:        'staff',
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  'DELETE',
						},
						{
							type:        'gate',
							gate:        'staff',
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  'UPLOAD',
						},
					],
				};

				$scope.modalAddPermission = () => {
					if ($scope.modalDirectory.permissions.length > 0) {
						const lastPermission = cloneDeep($scope.modalDirectory.permissions[$scope.modalDirectory.permissions.length - 1]);

						$scope.modalDirectory.permissions.push({
							type:        lastPermission.type,
							gate:        lastPermission.gate,
							category:    lastPermission.category,
							user:        lastPermission.user,
							serviceUser: lastPermission.serviceUser,
							permission:  '',
						});
					} else {
						$scope.modalDirectory.permissions.push({
							type:        '',
							gate:        null,
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  '',
						});
					}
				};

				$scope.modalRemovePermission = (index) => {
					$scope.modalDirectory.permissions.splice(index, 1);
				};

				$scope.modalResetPermission = (index) => {
					$scope.modalDirectory.permissions[index] = {
						...$scope.modalDirectory.permissions[index],
						gate:        null,
						category:    null,
						user:        null,
						serviceUser: null,
					};
				};

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					const directory = {
						name:        $scope.modalDirectory.name,
						parent:      $scope.modalDirectory.parent,
						permissions: [
							...normalizePermissionsForAPI($scope.modalDirectory.permissions),
						],
					};

					DocumentsDirectories.post(directory)
					                    .then((returnedDirectory) => {
						                    $uibModalInstance.close();

						                    $scope.refreshDirectories();
					                    })
					                    .catch((error) => {
						                    toastr.clear();
						                    toastr.error('There was an error while creating the new directory, please try again.', 'Error');

						                    $uibModalInstance.close();

						                    $scope.refreshDirectories();
					                    });
				};
			},
		});
	};

	$scope.directoryEditDirectory = (directoryId) => {
		$uibModal.open({
			animation:                  true,
			template:                   editModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.modalDirectory = null;

				$scope.modalOriginalDirectory = $scope.directoriesById[directoryId];

				$scope.modalStatus = STATUSES.LOADING;

				getDirectoryWithPermissionsAndParent(directoryId)
					.then((directory) => {
						$scope.modalDirectory = {
							...cloneDeep(directory),
							permissions: [
								...normalizePermissionsFromAPI(directory.permissions),
							],
						};

						$scope.modalStatus = STATUSES.LOADED;
					})
					.catch((error) => {
						$scope.modalStatus = STATUSES.ERRORED;

						toastr.clear();
						toastr.error('There was an error while loading the directory information, please try again.', 'Error');

						$uibModalInstance.close();
					});

				$scope.modalAddPermission = () => {
					if ($scope.modalDirectory.permissions.length > 0) {
						const lastPermission = cloneDeep($scope.modalDirectory.permissions[$scope.modalDirectory.permissions.length - 1]);

						$scope.modalDirectory.permissions.push({
							type:        lastPermission.type,
							gate:        lastPermission.gate,
							category:    lastPermission.category,
							user:        lastPermission.user,
							serviceUser: lastPermission.serviceUser,
							permission:  '',
						});
					} else {
						$scope.modalDirectory.permissions.push({
							type:        '',
							gate:        null,
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  '',
						});
					}
				};

				$scope.modalRemovePermission = (index) => {
					$scope.modalDirectory.permissions.splice(index, 1);
				};

				$scope.modalResetPermission = (index) => {
					$scope.modalDirectory.permissions[index] = {
						...$scope.modalDirectory.permissions[index],
						gate:        null,
						category:    null,
						user:        null,
						serviceUser: null,
					};
				};

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					if ($scope.modalStatus === STATUSES.LOADED) {
						const directory = {
							name:        $scope.modalDirectory.name,
							parent:      $scope.modalDirectory.parent,
							permissions: [
								...normalizePermissionsForAPI($scope.modalDirectory.permissions),
							],
						};

						DocumentsDirectories.one(directoryId)
						                    .customPUT(directory)
						                    .then((returnedDirectory) => {
							                    $uibModalInstance.close();

							                    $scope.refreshDirectories();
						                    })
						                    .catch((error) => {
							                    toastr.clear();
							                    toastr.error('There was an error while editing the directory, please try again.', 'Error');

							                    $uibModalInstance.close();

							                    $scope.refreshDirectories();
						                    });
					} else {
						toastr.clear();
						toastr.warning('Please wait for the directory information to load.', 'Loading...');
					}
				};
			},
		});
	};

	$scope.directoryMoveDirectory = (directoryId, before, after) => {
		$uibModal.open({
			animation:                  true,
			template:                   moveModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.modalDirectory = $scope.directoriesById[directoryId];

				const beforeParentDirectoryId = before.parentDirectoryId;

				if (beforeParentDirectoryId !== null) {
					$scope.modalBeforeParentDirectory = $scope.directoriesById[beforeParentDirectoryId];
				} else {
					$scope.modalBeforeParentDirectory = null;
				}

				const afterParentDirectoryId = after.parentDirectoryId;

				if (afterParentDirectoryId !== null) {
					$scope.modalAfterParentDirectory = $scope.directoriesById[afterParentDirectoryId];
				} else {
					$scope.modalAfterParentDirectory = null;
				}

				$scope.modalBeforeParentDirectoryName = ($scope.modalBeforeParentDirectory) ? ($scope.modalBeforeParentDirectory.name) : ('Root');
				$scope.modalAfterParentDirectoryName  = ($scope.modalAfterParentDirectory) ? ($scope.modalAfterParentDirectory.name) : ('Root');

				$scope.modalCancel = () => {
					$uibModalInstance.close();

					$scope.refreshDirectories();
				};

				$scope.modalConfirm = () => {
					const directory = {
						name:        $scope.modalDirectory.name,
						parent:      afterParentDirectoryId,
						permissions: null, // Permissions won't change if null is provided
					};

					DocumentsDirectories.one(directoryId)
					                    .customPUT(directory)
					                    .then((returnedDirectory) => {
						                    $uibModalInstance.close();

						                    $scope.refreshDirectories();
					                    })
					                    .catch((error) => {
						                    toastr.clear();
						                    toastr.error('There was an error while moving the directory, please try again.', 'Error');

						                    $uibModalInstance.close();

						                    $scope.refreshDirectories();
					                    });
				};
			},
		});
	};

	$scope.directoryDeleteDirectory = (directoryId) => {
		$uibModal.open({
			animation:                  true,
			template:                   deleteModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				const moveDescendantsToChildren = (directory) => {
					if (directory.descendants !== undefined) {
						directory.children = [
							...cloneDeep(directory.descendants),
						];

						delete directory.descendants;
					} else if (directory.children === undefined) {
						directory.children = [];
					}

					if (directory.documents === undefined) {
						directory.documents = [];
					}

					return directory;
				};

				const recursivelyPopulateEntitiesToDelete = (directory, directoryPrefix, entities) => {
					if (!directoryPrefix) {
						// The first directory
						directoryPrefix = directory.name;
					} else {
						// A child directory
						directoryPrefix = `${directoryPrefix} / ${directory.name}`;
					}

					entities.directories.push(directoryPrefix);

					angular.forEach(directory.documents, (document) => {
						entities.documents.push(`${directoryPrefix} / ${document.name}`);
					});

					angular.forEach(directory.children, (directory) => {
						recursivelyPopulateEntitiesToDelete(directory, directoryPrefix, entities);
					});
				};

				$scope.modalDirectory = null;

				$scope.modalOriginalDirectory = $scope.directoriesById[directoryId];

				$scope.modalStatus = STATUSES.LOADING;

				getDirectoryWithDescendantsAndParent(directoryId)
					.then((directory) => {
						directory = moveDescendantsToChildren(directory);

						let entitiesToDelete = {
							directories: [],
							documents:   [],
						};

						recursivelyPopulateEntitiesToDelete(directory, '', entitiesToDelete);

						$scope.modalDirectory        = directory;
						$scope.modalEntitiesToDelete = entitiesToDelete;

						$scope.modalStatus = STATUSES.LOADED;
					})
					.catch((error) => {
						$scope.modalStatus = STATUSES.ERRORED;

						toastr.clear();
						toastr.error('There was an error while loading the directory information, please try again.', 'Error');

						$uibModalInstance.close();
					});

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					if ($scope.modalStatus === STATUSES.LOADED) {
						DocumentsDirectories.one(directoryId)
						                    .remove()
						                    .then((response) => {
							                    $uibModalInstance.close();

							                    $scope.directorySelectDirectory($scope.modalOriginalDirectory.parent);

							                    $scope.refreshDirectories();
						                    })
						                    .catch((error) => {
							                    toastr.clear();
							                    toastr.error('There was an error while deleting the directory, please try again.', 'Error');

							                    $uibModalInstance.close();

							                    $scope.refreshDirectories();
						                    });
					} else {
						toastr.clear();
						toastr.warning('Please wait for the directory information to load.', 'Loading...');
					}
				};
			},
		});
	};

	$scope.refreshDirectory = () => {
		const populateDirectoryById = (directoryId) => {
			if ($scope.directoriesById[directoryId]) {
				let directory = $scope.directoriesById[directoryId];

				return {
					...directory,
					children:  directory.children.map((childDirectoryId) => {
						if ($scope.directoriesById[childDirectoryId]) {
							return $scope.directoriesById[childDirectoryId];
						} else {
							return null;
						}
					}),
					documents: directory.documents.map((documentId) => {
						if ($scope.documentsById[documentId]) {
							return $scope.documentsById[documentId];
						} else {
							return null;
						}
					}),
				};
			} else {
				return null;
			}
		};

		$scope.directory.status = STATUSES.LOADING;
		$scope.directory.data   = populateDirectoryById($scope.directoryId);

		DocumentsDirectories.one($scope.directoryId)
		                    .get({
			                    include: 'children,documents.latestVersion,parent',
		                    })
		                    .then((data) => {
			                    const normalizeDirectory = (directory) => {
				                    if (directory.children === undefined) {
					                    directory.children = [];
				                    }

				                    if (directory.documents === undefined) {
					                    directory.documents = [];
				                    }

				                    if (directory.parent !== undefined) {
					                    directory.parent = directory.parent.id;
				                    } else {
					                    directory.parent = null;
				                    }

				                    return directory;
			                    };

			                    const directory = normalizeDirectory(data);

			                    $scope.treeUpdateDirectoryEntity(directory);

			                    if (directory.id === $scope.directoryId) {
				                    $scope.directory.data   = directory;
				                    $scope.directory.status = STATUSES.LOADED;
			                    }

			                    // Otherwise this call was for a previous directory
		                    })
		                    .catch((error) => {
			                    toastr.clear();
			                    toastr.error('There was an error while loading the document manager, please try again.', 'Error');

			                    $scope.directory.status = STATUSES.ERRORED;
		                    });
	};

	$scope.$watch('directoryId', (newValue) => {
		$scope.refreshDirectory();
	});

	$scope.$watch('directoryViewType', (newValue) => {
		localStorageService.set('documents.directoryViewType', newValue);
	});

	const localStorageDirectoryViewType = localStorageService.get('documents.directoryViewType');

	if (localStorageDirectoryViewType) {
		$scope.directoryViewType = localStorageDirectoryViewType;
	} else {
		$scope.directoryViewType = 'grid';
	}
}


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/documents/root/controllers/directory/index.js